import { useEffect } from "react";
import { getWebsiteContent } from "../lib/database";
import { applyFavicon, DEFAULT_FAVICON } from "../lib/favicon";

export function useSiteFavicon() {
  useEffect(() => {
    applyFavicon(DEFAULT_FAVICON);
    let cancelled = false;

    getWebsiteContent("seo")
      .then((row) => {
        if (cancelled) return;
        const favicon = String((row as { content?: { favicon?: string } } | null)?.content?.favicon || "").trim();
        applyFavicon(favicon || DEFAULT_FAVICON);
      })
      .catch(() => {
        if (!cancelled) applyFavicon(DEFAULT_FAVICON);
      });

    return () => {
      cancelled = true;
    };
  }, []);
}
